// Function to fill a form with item details
export const fillForm = (item) => {
  return {
    id: item.id,
    url: item.url,
    imageUrl: item.imageUrl,
    section: item.section,
    isActive: item.isActive,
  };
};
